import {AaNaturalAnalog} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  BaseMonomerUpdate,
  BaseMonomerValidationFields,
  SharedMonomerCsvValidationOutput,
  SharedMonomerValidationOutput,
} from 'molbio/monomers/SharedMonomerConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export interface APIAaMonomer {
  name: string;
  symbol: string;
  naturalAnalog: AaNaturalAnalog;
  smiles: string;
  color: string;
  customMolecularWeight?: number | null;
}

export interface AaMonomerValidationInput extends BaseMonomerValidationFields {
  naturalAnalogue?: AaNaturalAnalog | null;
  color?: string | null;
}

export async function createAaMonomers(monomers: Array<APIAaMonomer>): Promise<{createdIds: Array<string>}> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers',
    data: {monomers},
  });
}

export async function updateAaMonomer(
  aaMonomerId: string,
  data: BaseMonomerUpdate
): Promise<{updatedIds: Array<string>}> {
  return await patchJSONPromise({
    url: '/1/api/aa-monomers',
    data: {monomers: [{id: aaMonomerId, ...data}]},
  });
}

export async function validateAaMonomerInput(
  monomerDicts: Array<AaMonomerValidationInput>
): Promise<Array<SharedMonomerValidationOutput>> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:validate',
    data: {monomerDicts},
  });
}

export async function validateAaMonomersFromFile(
  filename: string,
  url: string
): Promise<SharedMonomerCsvValidationOutput> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:validate-csv',
    data: {csvUrl: url, filename},
  });
}

export async function createAaMonomersFromFile(
  url: string,
  filename: string
): Promise<{createdIds: Array<string>}> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:bulk-create-from-csv',
    data: {csvUrl: url, filename},
  });
}

export async function exportAaMonomersAsCSV(forReimportIntoBenchling: boolean): Promise<{
  s3Location: string;
}> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:export-as-csv',
    data: {forReimportIntoBenchling},
  });
}

export async function archiveAaMonomers(monomerIds: Array<string>, purpose: string): Promise<void> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:archive',
    data: {monomerIds, purpose},
  });
}

export async function unarchiveAaMonomers(monomerIds: Array<string>): Promise<void> {
  return await postJSONPromise({
    url: '/1/api/aa-monomers:unarchive',
    data: {monomerIds},
  });
}
